export default __webpack_public_path__ + "static/media/AG02.0d8475c7.mp3";